module.exports = __webpack_public_path__ + "static/media/payments_active.31327bd6.svg";